import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  Modal,
  Radio,
  Row,
  Space,
  Tag,
} from "antd";
import { BsSendCheck } from "react-icons/bs";
import React, { useState } from "react";
import { BiCheck, BiSolidErrorCircle } from "react-icons/bi";
import { AiOutlineCalendar } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import "./Modals.css";
import { router } from "../../../engine/router/AppRouter";
import { colorPrimary } from "../../../root";
import { ExclamationCircleFilled } from "@ant-design/icons";
import {
  daysJsFormat,
  iconSwitchStatusControl,
  languagesList,
  renderUserName,
  statusPrestations,
} from "../../../utils/constants";

import {
  changeStatusInterprete,
  setSelectedInterprete,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import DownloadICS from "../DownloadICS/DownloadICS";
import { storeNew } from "../../../store/store.new";
import { Provider } from "react-redux";
import { PrestationCancel } from "./PrestationCancel";
import { InstitutionNewAddress } from "./InstitutionNewAddress";
import {
  FaCalendarAlt,
  FaCheck,
  FaCheckCircle,
  FaUserPlus,
} from "react-icons/fa";
import dayjs from "../../../utils/dayjs";
import routes from "../../../engine/routes";
import { renderDuplicateAddressHint } from "../../container/Addresses/AddresseItem/AddresseHelpers";
import dateFormat from "dateformat";
import Title from "antd/es/typography/Title";
import { CgDanger } from "react-icons/cg";
import { address } from "ip";
import { newAddresse } from "../../container/Addresses/AddressesSlice/Addresses.slice";

const sharedProps = {
  okButtonProps: {
    style: { backgroundColor: "var(--color-primary)", borderRadius: 2 },
    className: "ok-modal-button",
    size: "large",
  },
  cancelButtonProps: {
    size: "large",
    style: { borderRadius: 2 },
    className: "cancel-modal-button",
  },
};

export const defaultProps = {
  open: true,
  cancelText: "Annuler",
  okButtonProps: sharedProps.okButtonProps,
  cancelButtonProps: sharedProps.cancelButtonProps,
};

export const modalsByContext = {
  PrestationCancel: "PrestationCancel",
  PrestationFollow: "PrestationFollow",
  PrestationEditAdmin: "PrestationEditAdmin",
  InstitutionNewAddress: "InstitutionNewAddress",
  InstitutionSelectAddress: "InstitutionSelectAddress",
  PrestationControl: "PrestationControl",
  PrestationGrouped: "PrestationGrouped",
  SelectResponsable: "SelectResponsable",
};

export const confirmDraftDeleteByBatch = async ({
  onOk = () => {},
  onCancel = () => {},
  array,
}) =>
  Modal.confirm({
    width: 500,
    title: (
      <Space>
        <CgDanger style={{ color: colorPrimary }} size={25} />
        Voulez-vous vraiment supprimer ces prestations ?
      </Space>
    ),
    icon: null,
    content: (
      <div>
        <h4>
          Vous êtes sur le point de supprimer ces {array.length} prestations en
          brouillon.
        </h4>
        <p>Cette action est irréversible</p>
      </div>
    ),
    open: true,
    okText: `Supprimer ces ${array.length} prestations`,
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const confirmValidateDraftPrestation = async ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: "Confirmation de votre prestation",
    // icon: <BsSendCheck style={{ color: colorPrimary }} size={20} />,
    content: (
      <div>
        <h4>
          Vous êtes sur le point de valider et envoyer les emails d'invitation
          aux interprètes.
        </h4>
        <p>Vous ne pourrez plus éditer cette prestation sans approbation.</p>
      </div>
    ),
    open: true,
    okText: "Lancer la procédure",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const confirmLeaveDraftPrestation = ({
  onOk = () => {},
  onCancel = () => {},
}) => {
  let fired = false;
  return Modal.confirm({
    title: "Attention",
    content: (
      <div>
        <p>
          La demande n'a pas été finalisée. Pour la terminer, veuillez cliquer
          sur « Valider la commande ».
        </p>
      </div>
    ),
    ...defaultProps,
    okText: "Continuer la saisie",
    cancelText: "Quitter quand même",
    autoFocusButton: "ok",
    maskClosable: false,
    keyboard: false,
    closable: false,
    onOk: async () => {
      if (fired) return;
      fired = true;
      return onOk();
    },
    onCancel: async () => {
      if (fired) return;
      fired = true;
      return onCancel();
    },
  });
};

export const confirmManuelPrestation = async ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: "Finaliser votre prestation",
    // icon: <BsSendCheck style={{ color: colorPrimary }} size={20} />,
    content: (
      <div>
        <h4>
          Vous êtes sur le point de valider une prestation attribué à un
          interprète
        </h4>
        <p>La prestation passera en prévue.</p>
        <p>Vous ne pourrez plus éditer cette prestation sans approbation.</p>
      </div>
    ),
    open: true,
    okText: "Lancer la procédure",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

const RenderPrestatioNSame = ({ s, stat, lng }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      style={{
        color: isHovered ? "red" : "black",
        display: "block",
        marginBottom: 5,
      }}
      href={routes.prestations(s._id).detail.path}
      target={"_blank"}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Tag size={"middle"} color={stat.color}>
        {stat.label}
      </Tag>{" "}
      - {dayjs(s.finalStartDate).format(daysJsFormat.hour)} à{" "}
      {dayjs(s.finalEndDate).format(daysJsFormat.hour)}
      {s?.interprete ? " - " + renderUserName(s?.interprete) : ""}{" "}
      {lng ? ` - ${lng}` : ""}
      <Tag color={"red"}>{s.reference}</Tag>
    </a>
  );
};
export const prestationAlreadyExist = async ({
  onOk = () => {},
  onCancel = () => {},
  content = {},
}) =>
  Modal.confirm({
    width: 600,
    title: "Cette prestation semble deja exister dans le système",
    content: (
      <div>
        <p>
          Avant de la finaliser, merci de vérifier qu'il ne s'agisse pas d'un
          doublon.
        </p>
        <span>
          Prestations potentiellement identiques:
          <br />
          <br />
          {content.prestations.map(s => {
            let stat = statusPrestations.find(a => a.value === s.status);
            let lng = languagesList.find(c => c.value === s.language[0])?.label;

            return <RenderPrestatioNSame stat={stat} s={s} lng={lng} />;
          })}
        </span>
      </div>
    ),
    open: true,
    okText: "Je confirme",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const prestationAddressAlreadyExist = async ({
  onOk = () => {},
  onCancel = () => {},
  content = {},
}) =>
  Modal.confirm({
    width: 800,
    title: "Ce lieu d’intervention semble deja exister dans le système",
    content: (
      <div>
        <p>
          Avant de la finaliser, merci de vérifier qu'il ne s'agisse pas d'un
          doublon
        </p>
        <span>
          Lieu d’intervention potentiellement identique :
          <br />
          <br />
          {content.addresses.map(s => (
            <div
              key={s._id ?? `${s.latitude}-${s.longitude}-${s.type}`}
              style={{
                border: "1px solid #c8c8c8",
                padding: 3,
                borderRadius: 3,
                margin: 3,
              }}
            >
              {renderDuplicateAddressHint(s)}
            </div>
          ))}
        </span>
      </div>
    ),
    open: true,
    okText: "Je confirme devoir créer une nouvelle adresse",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const newPrestationSelectors = async ({
  onOk = () => {},
  onCancel = () => {},
  content,
}) => {
  return Modal.info({
    width: 820,
    icon: null,
    title: null,
    maskClosable: true,
    closable: true,
    content: (
      <>
        <div>
          <Title level={2} style={{ textAlign: "center" }}>
            Choisissez votre méthode de création de prestation
          </Title>
        </div>
        <br />
        <Row gutter={[10, 10]}>
          <Col sm={24} md={12}>
            <Card
              style={{
                backgroundColor: "#f3f3f3",
              }}
              title={
                <Title level={4} style={{ textAlign: "center", marginTop: 20 }}>
                  Création par date
                </Title>
              }
              bodyStyle={{
                paddingTop: 5,
              }}
            >
              <p style={{ textAlign: "center" }}>
                Planifiez une prestation à une date précise et invitez les
                interprètes disponibles.
              </p>
              <Button
                {...sharedProps.okButtonProps}
                type={"default"}
                className={"confirmButton  extraSizeButton"}
                onClick={() => {
                  content.navigate(routes.prestations("new").new.path, {
                    replace: true,
                  });
                  Modal.destroyAll();
                }}
              >
                <Space direction={"horizontal"}>
                  <FaCalendarAlt size={20} style={{ marginTop: -5 }} />
                  Rechercher une date
                </Space>
              </Button>
            </Card>
          </Col>

          <Col sm={24} md={12}>
            <Card
              style={{
                backgroundColor: "#f3f3f3",
              }}
              title={
                <Title level={4} style={{ textAlign: "center", marginTop: 20 }}>
                  Création par interprète
                </Title>
              }
              bodyStyle={{
                paddingTop: 5,
              }}
            >
              <p style={{ textAlign: "center" }}>
                Sélectionnez un interprète en fonction de sa langue et de ses
                disponibilités.
              </p>
              <Button
                {...sharedProps.okButtonProps}
                type={"default"}
                className={"confirmButton  extraSizeButton"}
                onClick={() => {
                  content.navigate(routes.prestations("new").selector.path, {
                    replace: true,
                  });
                  Modal.destroyAll();
                }}
              >
                <Space direction={"horizontal"}>
                  <FaUserPlus size={22} style={{ marginTop: -5 }} />
                  Rechercher un(e) interprète
                </Space>
              </Button>
            </Card>
          </Col>
        </Row>
      </>
    ),
    open: true,
    okText: "Je confirme",
    okButtonProps: {
      ...sharedProps.okButtonProps,
      style: {
        display: "none",
        ...sharedProps.okButtonProps.style,
      },
    },
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });
};

export const manuelAttributeInterprete = async ({
  onOk = () => {},
  onCancel = () => {},
  content = {},
}) =>
  Modal.confirm({
    title: "Attribuer manuellement cet interprète ?",
    content: (
      <div>
        <p>La prestation passera directement en prévue après sauvegarde.</p>
        <span>
          Concerne: <b>{renderUserName(content.record.interprete)}</b>
        </span>
      </div>
    ),
    open: true,
    okText: "Je confirme",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });
export const confirmRelanceInterpreteInvitation = async ({
  onOk = () => {},
  onCancel = () => {},
  content = {},
}) =>
  Modal.confirm({
    title: "Voulez-vous relancer l'invitation?",
    content: (
      <div>
        <p>{renderUserName(content?.user)} recevra une nouvelle invitation</p>
      </div>
    ),
    open: true,
    okText: "Je confirme",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const confirmDirecteInterpreteInvitation = async ({
  onOk = () => {},
  onCancel = () => {},
  content = {},
}) =>
  Modal.confirm({
    title: "Voulez-vous envoyer une invitation ?",
    content: (
      <div>
        <p>
          {renderUserName(content?.user)} recevra immédiatement une invitation
        </p>
      </div>
    ),
    open: true,
    okText: "Je confirme",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const modalAnswerPrestationInvitation = async ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: "Merci de confirmer la prestation",
    // icon: <BsSendCheck style={{ color: colorPrimary }} size={20} />,
    content: <div>Cette prestation vous sera attitrée </div>,
    open: true,
    okText: "Accepter",
    cancelText: "Annuler",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const modalModificationPrestationPending = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: "Modification de la prestation",
    content: (
      <div>
        <h4>Valider la modification ?</h4>
        <p>
          L'interprète devra accepter ou refuser les modifications de la
          prestation.
        </p>
        <p>Vous serez informé par email de la décision de l'interprète.</p>
      </div>
    ),
    open: true,
    okText: "Valider la modification",
    cancelText: "Annuler",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

// The booking changed while the page was open: nothing was saved and the page is reloaded.
export const modalPrestationChangedReload = ({ onOk = () => {} }) =>
  Modal.warning({
    title: "La prestation a changé",
    content: (
      <div>
        <p>
          Cette prestation a été modifiée pendant que la page était ouverte.
          Votre modification n'a pas été enregistrée.
        </p>
        <p>
          La page va être rechargée avec les dernières informations. Vous
          pourrez ensuite refaire votre modification.
        </p>
      </div>
    ),
    open: true,
    okText: "Recharger la page",
    okButtonProps: sharedProps.okButtonProps,
    keyboard: false,
    onOk: () => onOk(),
  });

export const modalConfirmDeleteBill = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: "Suppression de la facture",
    content: (
      <div>
        <h4>Êtes-vous sur de supprimer cette facture ?</h4>
        <p>
          Il faudrait la regénérer soit depuis la prestation soit depuis
          l'institution pour les factures groupées
        </p>
      </div>
    ),
    open: true,
    okText: "Confirmer la suppression",
    cancelText: "Annuler",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const modalModificationPrestationFinishPending = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: "Modification de la prestation",
    content: (
      <div>
        <h4>Vous modifier une prestation terminée ?</h4>
        <p>Cette action modifiera la facture associée.</p>
      </div>
    ),
    open: true,
    okText: "Valider la modification",
    cancelText: "Annuler",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const interpreteAcceptModification = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: "Approuver les changements de la prestation ?",
    content: (
      <div>
        <h4>Validez-vous les changements ?</h4>
      </div>
    ),
    open: true,
    okText: "Approuver les changements",
    cancelText: "Annuler",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const confirmDeletebatch = ({ onOk = () => {}, onCancel = () => {} }) =>
  Modal.confirm({
    title: "Confirmer la suppression du groupe ?",
    content: (
      <div>
        <h4>Validez-vous la suppression ?</h4>
      </div>
    ),
    open: true,
    okText: "Confirmer ",
    cancelText: "Annuler",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const interpreteRefuseModification = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: "Refuser les changements de la prestation ?",
    content: (
      <div>
        <h4>Refusez-vous les changements ?</h4>
        <p>Si vous refusez les changements, la prestation sera annulée.</p>
      </div>
    ),
    open: true,
    okText: "Refuser les changements",
    cancelText: "Annuler",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const userIntervenantDuplicate = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: "Cet email est déja dans le système",
    content: (
      <div>
        <h4>Que souhaitez-vous faire ?</h4>
        <p>
          Vous pouvez mettre à jour l'utilisateur ou modifier les informations
          saisies dans le formulaire
        </p>
      </div>
    ),
    open: true,
    okText: "Confirmer la mise à jour",
    cancelText: "Annuler",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const userIntervenantDuplicateLink = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: "Cet email est déja dans le système",
    content: (
      <div>
        <h4>Que souhaitez-vous faire ?</h4>
        <p>
          Allez directement sur l'utilisateur existant ou modifier les
          informations saisies dans le formulaire
        </p>
      </div>
    ),
    open: true,
    okText: "Allez sur le l'utilisateur",
    cancelText: "Annuler",
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const confirmAnswerYesPrestation = async ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    width: "60%",
    icon: null,
    content: (
      <div className={"center-full"}>
        <div className={"confirmYes"}>
          <div className={"checkBig"}>
            <BiCheck color={colorPrimary} size={60} />
          </div>
          <h3>Merci d'avoir accepté la prestation</h3>

          <p>
            Votre confirmation a été transmise à l'institution concernée, vous
            retrouverez de détail de la préstation sur votre compte AVIC
          </p>
          <Row style={{ width: "100%" }}>
            <Col md={12} xs={24}>
              <Provider store={storeNew}>
                <DownloadICS type={"button"} />
              </Provider>
            </Col>
            <Col md={12} xs={24}>
              <Button
                size={"large"}
                className={"confirmButton forceNormal"}
                onClick={() => {
                  router.navigate("/", { replace: true });
                  Modal.destroyAll();
                }}
              >
                Retour à l'accueil
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    ),
    footer: null,
    okText: "Accepter",
    cancelText: "Annuler",
    ...defaultProps,
    onOk: async () => onOk(),
    onCancel: async () => {
      router.navigate("/", { replace: true });
      Modal.destroyAll();
    },
  });

export const prestationsFinishSuccess = ({
  onOk = () => {},
  onCancel = () => {},
  user,
}) =>
  Modal.confirm({
    title: <h2>Prestation terminée</h2>,
    content: (
      <div className={"confirmYes"}>
        <div className={"checkBig"} style={{ textAlign: "center" }}>
          <BiCheck color={colorPrimary} size={60} />
        </div>

        <p>
          Nous vous remercions pour votre collaboration, la prestation est
          désormais terminée.
        </p>
      </div>
    ),
    icon: null,
    ...defaultProps,
    okText: "Retour à la liste",
    cancelText: "Fermer",
    onOk,
    onCancel,
  });

export const confirmDeletePrestation = ({
  onOk = () => {},
  onCancel = () => {},
}) => {
  let fired = false;
  return Modal.confirm({
    title: "Suppression de la prestation",
    content: (
      <div>
        <h4>Voulez-vous supprimer cette prestation ?</h4>
        <p>
          Cette prestation n'a pas été publiée. Il n'y aura aucune conséquence
          sur le processus.
        </p>
      </div>
    ),
    ...defaultProps,
    okText: "Supprimer la prestation",
    onOk: async () => {
      if (fired) return;
      fired = true;
      return onOk();
    },
    onCancel,
  });
};

export const validIcon = <FaCheckCircle color={"green"} size={18} />;
export const errorIcon = <BiSolidErrorCircle color={"red"} size={20} />;

export const confirmDeleteInstitution = ({
  onOk = () => {},
  onCancel = () => {},
  props,
}) => {
  // HELLO

  return Modal.confirm({
    title: "Suppression de l'institution",
    content: (
      <div>
        <h4>Voulez-vous supprimer cette institution ?</h4>
        <p>
          Les données de l'institution doivent être vide avant de pouvoir
          supprimer une institution
        </p>

        <p>Les 4 voyants suivant doivent être au vert</p>

        <Alert
          size={"small"}
          icon={props.users.length > 0 ? errorIcon : validIcon}
          message={
            props.users.length > 0 ? (
              <>Il y a encore {props.users.length} utilisateurs.</>
            ) : (
              <>Aucun utilisateur.</>
            )
          }
          type={props.users.length > 0 ? "error" : "success"}
          showIcon
        />

        <Alert
          size={"small"}
          icon={props.address.length > 0 ? errorIcon : validIcon}
          message={
            props.address.length > 0 ? (
              <>Il y a encore {props.address.length} adresses.</>
            ) : (
              <>Aucune addresse.</>
            )
          }
          type={props.address.length > 0 ? "error" : "success"}
          showIcon
        />
        <Alert
          size={"small"}
          icon={props.sharedToInstitutions.length > 0 ? errorIcon : validIcon}
          message={
            props.sharedToInstitutions.length > 0 ? (
              <>
                L'institution est dans {props.sharedToInstitutions.length}{" "}
                adresse partagée.
              </>
            ) : (
              <>Aucune addresse partagée.</>
            )
          }
          type={props.sharedToInstitutions.length > 0 ? "error" : "success"}
          showIcon
        />

        <Alert
          size={"small"}
          icon={props.principal !== null ? errorIcon : validIcon}
          message={
            props.principal !== null ? (
              <>Est lié à un mandant.</>
            ) : (
              <>N'est pas lié à un mandant.</>
            )
          }
          type={props.principal !== null ? "error" : "success"}
          showIcon
        />

        <Alert
          size={"small"}
          icon={props.prestations.length > 0 ? errorIcon : validIcon}
          message={
            props.prestations.length > 0 ? (
              <>Il y a encore {props.prestations.length} prestations.</>
            ) : (
              <>Aucune prestation.</>
            )
          }
          description={
            props.prestations.length > 0 ? (
              <>
                {props.prestations.map(prestation => (
                  <Tag>
                    <a
                      href={routes.prestations(prestation._id).detail.path}
                      target={"_blank"}
                    >
                      {prestation.reference}
                    </a>
                  </Tag>
                ))}
              </>
            ) : (
              undefined
            )
          }
          type={props.prestations.length > 0 ? "error" : "success"}
          showIcon
        />

        <Alert
          size={"small"}
          icon={props.bills.length > 0 ? errorIcon : validIcon}
          message={
            props.bills.length > 0 ? (
              <>Il y a encore {props.bills.length} factures.</>
            ) : (
              <>Aucune facture.</>
            )
          }
          description={
            props.bills.length > 0 ? (
              <>
                {props.bills.map(bill => (
                  <Tag>
                    <a
                      href={routes.billing(bill._id).detail.path}
                      target={"_blank"}
                    >
                      {bill.bill_number}
                    </a>
                  </Tag>
                ))}
              </>
            ) : (
              undefined
            )
          }
          type={props.bills.length > 0 ? "error" : "success"}
          showIcon
        />
      </div>
    ),
    width: 600,
    ...defaultProps,
    okButtonProps:
      props.bills.length === 0 &&
      props.prestations.length === 0 &&
      props.address.length === 0 &&
      props.principal === null &&
      props.users.length === 0
        ? defaultProps.okButtonProps
        : { size: "large", style: { borderRadius: 2 }, disabled: true },
    okText: "Supprimer l'institution",
    onOk,
    onCancel,
  });
};

export const confirmDeleteAddress = ({
  onOk = () => {},
  onCancel = () => {},
  props,
}) => {
  return Modal.confirm({
    title: "Suppression de l'adresse",
    content: (
      <div>
        <h4>Voulez-vous supprimer cette adresse ?</h4>
        <p>
          L'adresse ne doit pas être utilisée dans des prestations ou factures
          avant de pouvoir être supprimée.
        </p>

        <Alert
          size={"small"}
          icon={props.prestations.length > 0 ? errorIcon : validIcon}
          message={
            props.prestations.length > 0 ? (
              <>
                Utilisée dans {props.prestations.length} prestation
                {props.prestations.length > 1 ? "s" : ""}.
              </>
            ) : (
              <>Aucune prestation liée.</>
            )
          }
          description={
            props.prestations.length > 0 ? (
              <>
                {props.prestations.map(prestation => (
                  <Tag key={prestation._id}>
                    <a
                      href={routes.prestations(prestation._id).detail.path}
                      target={"_blank"}
                    >
                      {prestation.reference}
                    </a>
                  </Tag>
                ))}
              </>
            ) : (
              undefined
            )
          }
          type={props.prestations.length > 0 ? "error" : "success"}
          showIcon
        />

        <Alert
          size={"small"}
          icon={props.bills.length > 0 ? errorIcon : validIcon}
          message={
            props.bills.length > 0 ? (
              <>
                Utilisée dans {props.bills.length} facture
                {props.bills.length > 1 ? "s" : ""}.
              </>
            ) : (
              <>Aucune facture liée.</>
            )
          }
          description={
            props.bills.length > 0 ? (
              <>
                {props.bills.map(bill => (
                  <Tag key={bill._id}>
                    <a
                      href={routes.billing(bill._id).detail.path}
                      target={"_blank"}
                    >
                      {bill.bill_number}
                    </a>
                  </Tag>
                ))}
              </>
            ) : (
              undefined
            )
          }
          type={props.bills.length > 0 ? "error" : "success"}
          showIcon
        />
      </div>
    ),
    width: 600,
    ...defaultProps,
    okButtonProps:
      props.prestations.length === 0 && props.bills.length === 0
        ? defaultProps.okButtonProps
        : { size: "large", style: { borderRadius: 2 }, disabled: true },
    okText: "Supprimer l'adresse",
    onOk,
    onCancel,
  });
};

export const confirmDeleteUserInstitution = ({
  onOk = () => {},
  onCancel = () => {},
  props,
}) => {
  const validIcon = <FaCheckCircle color={"green"} size={18} />;
  const errorIcon = <BiSolidErrorCircle color={"red"} size={20} />;

  return Modal.confirm({
    title: "Suppression de l'utilisateur",
    content: (
      <div>
        <h4>Voulez-vous supprimer cet utilisateur ?</h4>

        <p>L'utilisateur ne doit pas être lié à des prestations</p>

        <Alert
          size={"small"}
          icon={props.prestations.length > 0 ? errorIcon : validIcon}
          message={
            props.prestations.length > 0 ? (
              <>Il y a encore {props.prestations.length} prestations.</>
            ) : (
              <>aucune prestation liée.</>
            )
          }
          description={
            props.prestations.length > 0 ? (
              <>
                {props.prestations.map(prestation => (
                  <Tag>
                    <a
                      href={routes.prestations(prestation._id).detail.path}
                      target={"_blank"}
                    >
                      {prestation.reference}
                    </a>
                  </Tag>
                ))}
              </>
            ) : (
              undefined
            )
          }
          type={props.prestations.length > 0 ? "error" : "success"}
          showIcon
        />
      </div>
    ),
    width: 600,
    ...defaultProps,
    okButtonProps:
      props.prestations.length === 0
        ? defaultProps.okButtonProps
        : { size: "large", style: { borderRadius: 2 }, disabled: true },
    okText: "Supprimer l'utilisateur",
    onOk,
    onCancel,
  });
};

export const confirmFinalUserDelete = ({
  onOk = () => {},
  onCancel = () => {},
  user,
}) => {
  return Modal.confirm({
    title: "Vous êtes sur le point de supprimer un utilisateur",
    content: (
      <div>
        <p>Cet utilisateur est éligible à la suppression :</p>
        <b>{renderUserName(user)}</b>
      </div>
    ),
    ...defaultProps,
    okText: "Supprimer !",
    onOk,
    icon: <ExclamationCircleFilled style={{ color: "red" }} />,
    onCancel,
  });
};

export const confirmFinalInstitutionDelete = ({
  onOk = () => {},
  onCancel = () => {},
  institution,
}) => {
  return Modal.confirm({
    title: "Vous êtes sur le point de supprimer cet institution",
    content: (
      <div>
        <p>Cet institution est éligible à la suppression :</p>
        <b>{institution.name}</b>
      </div>
    ),
    ...defaultProps,
    okText: "Supprimer !",
    onOk,
    icon: <ExclamationCircleFilled style={{ color: "red" }} />,
    onCancel,
  });
};

export const confirmFinishPrestation = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: "Voulez-vous terminée la prestation ?",
    width: 400,
    content: (
      <div>
        <p>
          Vous êtes sur le point de clôturer une prestation{" "}
          <b>qui a effectivement eu lieu</b>, cette prestation sera donc
          facturée !{" "}
          <span style={{ textDecoration: "underline" }}>
            Ceci n'est PAS une annulation.
          </span>{" "}
          Pour toute annulation, merci de contacter la permanence.
        </p>
        <p>
          Il ne sera plus possible de modifier cette prestation et le
          responsable recevra un email de confirmation.
        </p>
      </div>
    ),
    ...defaultProps,
    okText: "Terminer",
    onOk,
    onCancel,
  });

export const askNewSearchInterpretesPrestation = ({
  onOk = () => {},
  onCancel = () => {},
  date,
}) =>
  Modal.confirm({
    title: "Critères de recherche modifiés",
    width: 400,
    content: (
      <div>
        <p>Souhaitez-vous relancer la recherche d'interprète ?</p>
        <p>
          Votre dernière recherche date du : <br />{" "}
          <b>{dayjs(date).format(daysJsFormat.full)}.</b>
        </p>
      </div>
    ),
    ...defaultProps,
    okText: "Relancer la recherche",
    onOk,
    onCancel,
  });

export const confirmCancelPrestation = ({
  onOk = () => {},
  onCancel = () => {},
  user,
}) =>
  Modal.confirm({
    width: "70%",
    title: "Voulez-vous annuler la prestation ?",
    content: (
      <div>
        <PrestationCancel />
        <p>
          Il ne sera pas possible de venir en arriète pour cette prestation et
          le responsable recevra une notification.
        </p>
        <h4>Raison de l'annulation</h4>
        <Radio.Group>
          <Space
            direction="vertical"
            style={{ marginBottom: 10 }}
            size={"small"}
          >
            <Radio value={"institution"}>
              Annulation demandée par l'institution
            </Radio>
            <Radio value={"interprète"}>
              {" "}
              Annulation demandée par l'interprète
            </Radio>
            <Radio value={"permanance"}> Annulation par la permanance</Radio>
          </Space>
        </Radio.Group>
        <br />
        <label>
          <h4>Remarque</h4>
          <Input.TextArea placeholder={"Remarque"} rows={4} />
        </label>
        <br />
        <br />
        <h4>Options de notification par email</h4>

        <Checkbox.Group className={"customform-radio"}>
          <Space
            direction="vertical"
            style={{ marginBottom: 10 }}
            size={"small"}
          >
            <Checkbox value={"interprete"}>
              <Space direction="vertical">
                <span style={{ fontWeight: 700 }}>Notifier l'interprète</span>
              </Space>
            </Checkbox>
            <Checkbox value={"demandeur"}>
              <Space direction="vertical">
                <span style={{ fontWeight: 700 }}>Notifier le demandeur</span>
              </Space>
            </Checkbox>
          </Space>
        </Checkbox.Group>
      </div>
    ),
    ...defaultProps,
    cancelText: "Fermer",
    okText: "Je veux annuler la prestation",
    onOk,
    onCancel,
  });

export const confirmDuplicatePrestation = ({
  onOk = () => {},
  onCancel = () => {},
  user,
}) => {
  let fired = false;
  return Modal.confirm({
    title: "Voulez-vous dupliquer la prestation ?",
    content: (
      <div>
        <p>Cette action créera une copie en état Brouillon</p>
      </div>
    ),
    ...defaultProps,
    okText: "Dupliquer",
    onOk: async () => {
      if (fired) return;
      fired = true;
      return onOk();
    },
    onCancel,
  });
};
